/**
 * Get environment-specific URLs for paid app and blog
 */
export function getEnvUrls() {
  const env = process.env.ENV;
  // Paid App URL - handle trailing slashes from env vars
  let paidAppUrlWithDomain = process.env.PAID_UI_URL;
  if (paidAppUrlWithDomain) {
    // Remove trailing slash if present
    paidAppUrlWithDomain = paidAppUrlWithDomain.replace(/\/$/, '');
  } else if (env === 'devhtz' || env === 'devlocal') {
    paidAppUrlWithDomain = 'https://app-dev.adbeat.com';
  } else if (env === 'betahtz') {
    paidAppUrlWithDomain = 'https://app-beta.adbeat.com';
  } else {
    paidAppUrlWithDomain = 'https://app.adbeat.com';
  }
  /*
  // Main App URL - same as above
  let mainUrlWithDomain = process.env.MAIN_URL;
  if (mainUrlWithDomain) {
    // Remove trailing slash if present
    mainUrlWithDomain = mainUrlWithDomain.replace(/\/$/, '');
  } else if (env === 'devhtz' || env === 'devlocal') {
    mainUrlWithDomain = 'https://dev.adbeat.com';
  } else if (env === 'betahtz') {
    mainUrlWithDomain = 'https://beta.adbeat.com';
  } else {
    mainUrlWithDomain = 'https://www.adbeat.com';
  }
  */
  const paidAppUrl = '/app';


  // Blog URL
  const blogUrl = process.env.BLOG_URL || 'https://blog.adbeat.com';

  return {
    paidAppUrl,
    blogUrl,
    paidAppUrlWithDomain
    // mainUrlWithDomain
  };
}

/**
 * Build canonical paid app URL. Examples:
 * /dashboard -> /app?p=dashboard
 * /tools/reports -> /app?p=tools/reports
 */
export function paidAppPathToUrl(path: string): string {
  const input = path.trim();
  if (!input || input === '/') {
    return '/app';
  }

  const normalized = input.startsWith('/') ? input : `/${input}`;
  const url = new URL(normalized, 'http://localhost');

  let paidPath = url.pathname;
  if (paidPath === '/app') {
    paidPath = '';
  } else if (paidPath.startsWith('/app/')) {
    paidPath = paidPath.slice('/app/'.length);
  } else {
    paidPath = paidPath.replace(/^\//, '');
  }
  paidPath = paidPath.replace(/\/+$/, '');

  const query = new URLSearchParams(url.search);
  if (paidPath) {
    const slashPreservingP = paidPath
      .split('/')
      .map((segment) => encodeURIComponent(segment))
      .join('/');
    query.set('p', '__PAID_PATH__');

    const queryString = query
      .toString()
      .replace('p=__PAID_PATH__', `p=${slashPreservingP}`);

    return queryString ? `/app?${queryString}${url.hash}` : `/app?p=${slashPreservingP}${url.hash}`;
  }

  const queryString = query.toString();
  return queryString ? `/app?${queryString}${url.hash}` : `/app${url.hash}`;
}

/**
 * Safely join a base URL with a path, ensuring no double slashes
 */
export function joinUrl(baseUrl: string, path: string): string {
  if (baseUrl === '/app') {
    return paidAppPathToUrl(path);
  }

  // Remove trailing slash from base URL
  const base = baseUrl.replace(/\/$/, '');
  // Ensure path starts with a single slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
